import React from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter } from 'react-router-dom'

import App from '../App'
import '../styles/application.css'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Projections refresh hourly at most, so aggressive refetching just
      // burns requests against Sleeper's rate ceiling.
      staleTime: 5 * 60 * 1000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
})

document.addEventListener('DOMContentLoaded', () => {
  const container = document.getElementById('root')
  if (!container) return

  createRoot(container).render(
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </QueryClientProvider>
    </React.StrictMode>
  )
})
